import { getDailyQuote } from "../constants/quotes";

export default function LoadingScreen() {
  const quote = getDailyQuote();

  return (
    <div className="loading-screen">
      <div className="loading-rings">
        <div className="loading-ring loading-ring-outer" />
        <div className="loading-ring loading-ring-inner" />
        <div className="loading-emoji">🔥</div>
      </div>

      <div className="loading-title">1% Better Everyday</div>

      <div className="loading-quote-card">
        <div className="loading-quote-text">"{quote.text}"</div>
        <div className="loading-quote-author">— {quote.author}</div>
      </div>

      <div className="loading-dots">
        <span className="loading-dot" />
        <span className="loading-dot" />
        <span className="loading-dot" />
      </div>
    </div>
  );
}
